import styled from 'styled-components'
import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'

export const NetworkAIBackIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
  margin: 0px 15px 15px 15px;
`

export const NetworkAIBackButton = styled(CommonLinkButton)`
  display: flex;
  font-size: 14px;
  justify-content: flex-start;
  color: ${theme.colors.otterWarmBlack};
`
